const BASE_PATH = "";

export const PathLink = (path = "") => `${BASE_PATH}${path}`;